import DataDisplayRowI from "../DataDisplayRowI";
import getFastPassRow from "../DataDisplayRow/FastPassRow";
import DataDisplayTable from "../DataDisplayTable";

class FastPassTable extends DataDisplayTable {
    generateRow(): DataDisplayRowI {
        return getFastPassRow()
    }
}

let fastPassTable: FastPassTable | null = null;

export default function getFastPassTable(): FastPassTable {
    if (fastPassTable === null)
        fastPassTable = new FastPassTable()
    return fastPassTable
}
